import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { store } from './app/store';
import App from './App';
import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import ThemedApp from './features/Themes/ThemedApp';
import ErrorBoundary from './ErrorBoundary';
import './muiLicense';
import './utils/masqueradeInterceptor';
import './utils/errorInterceptor';
import './utils/clientErrorReporter';

Amplify.configure(awsconfig);

let persistor = persistStore(store);

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Authenticator.Provider>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <ThemedApp>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </ThemedApp>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </Authenticator.Provider>,
);
